import { Container, Row, Col } from "react-bootstrap";
import footerImg from "../assets/images/footerImg.png";
import { IoCall } from "react-icons/io5";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer-section" id="contact">
      <img src={footerImg} alt="footer-img" className="footer-bg" />

      <Container fluid className="section-container">
        <h1 className="footer-title mb-3">Contact</h1>

        <Row className="footer-content">
          <Col md={4}>
            <h4 className="footer-company">FCi techlabs Private Limited</h4>

            <Link
              to="https://maps.app.goo.gl/H128H6KFvrR5Dm5u5"
              target="_blank"
            >
              <p>
                <FaMapMarkerAlt /> 901, Peninsula Heights, C.D Barfiwalal Lane,
                Above Jeep Showroom, Andheri West, Mumbai - (400058).
              </p>
            </Link>
          </Col>

          <Col md={{ span: 4, offset: 3 }}>
            <ul className="footer-info">
              <li>
                <Link to="mailto:sales@fcitechlabs.com">
                  <p className="m-0">
                    <FaEnvelope /> sales@fcitechlabs.com
                  </p>
                </Link>
              </li>

              <li>
                <Link to="mailto:info@fcitechlabs.com">
                  <p className="m-0">
                    <FaEnvelope /> info@fcitechlabs.com
                  </p>
                </Link>
              </li>
              <li>
                <IoCall size={20} />
                +91 9876543210
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
